import { useCallback, useState } from 'react';
import { Segmented } from 'antd';
import { AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';

import { useT } from '../../../../i18n';

export type KieuHien = 'luoi' | 'danh_sach';

const TIEN_TO_KHOA = 'foxai.tro_ly_ai.kieu_hien.';

function docDaLuu(khoa: string): KieuHien {
  try {
    return window.localStorage.getItem(TIEN_TO_KHOA + khoa) === 'danh_sach' ? 'danh_sach' : 'luoi';
  } catch {
    // Trình duyệt chặn bộ nhớ cục bộ: vẫn dùng được, chỉ không nhớ lựa chọn.
    return 'luoi';
  }
}

/**
 * Dạng lưới hay dạng danh sách của MỘT màn, nhớ qua lần tải trang. Mỗi màn một khoá riêng: người để Kho dữ liệu dạng
 * danh sách không vì thế mà muốn màn chọn bot cũng thành danh sách.
 */
export function useKieuHien(khoa: string): [KieuHien, (k: KieuHien) => void] {
  const [kieu, setKieu] = useState<KieuHien>(() => docDaLuu(khoa));
  const dat = useCallback(
    (k: KieuHien) => {
      setKieu(k);
      try {
        window.localStorage.setItem(TIEN_TO_KHOA + khoa, k);
      } catch {
        // Như trên.
      }
    },
    [khoa],
  );
  return [kieu, dat];
}

export function ChonKieuHien({ value, onChange }: { value: KieuHien; onChange: (k: KieuHien) => void }) {
  const { t } = useT();
  return (
    <Segmented<KieuHien>
      size="small"
      aria-label={t('troLyAi.kieuHien.nhan')}
      value={value}
      onChange={onChange}
      options={[
        {
          value: 'luoi',
          icon: <AppstoreOutlined />,
          title: t('troLyAi.kieuHien.luoi'),
          label: <span className="sr-only">{t('troLyAi.kieuHien.luoi')}</span>,
        },
        {
          value: 'danh_sach',
          icon: <UnorderedListOutlined />,
          title: t('troLyAi.kieuHien.danhSach'),
          label: <span className="sr-only">{t('troLyAi.kieuHien.danhSach')}</span>,
        },
      ]}
    />
  );
}
